import { retryEvent } from "@/utils/retryEvent";

export const PINTEREST_TAG_ID =
  process.env.NEXT_PUBLIC_PINTEREST_TAG_ID || "";

// https://developers.pinterest.com/docs/api/v5/conversion-events/
export const ppageview = (): void => {
  retryEvent(
    "pintrk",
    () => typeof window !== "undefined" && !!window.pintrk,
    () => {
      window.pintrk!("page");
      window.pintrk!("track", "pagevisit", {
        event_id: `pagevisit_${Date.now()}`,
      });
    }
  );
};

export const ptrackEvent = (
  name: string,
  options: Record<string, unknown> = {}
): void => {
  retryEvent(
    "pintrk",
    () => typeof window !== "undefined" && !!window.pintrk,
    () => window.pintrk!("track", name, options)
  );
};
